<template>
  <div class="deviceType">
    <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess"
      :wrapperClosable="false" direction="rtl" ref="drawer">
      <device-drawer v-if="drawerShow" :editData="selectData" :handleType="handleType" :loading.sync="loading"
        @confirm="handleConfirm" @cancel="handleCancel"></device-drawer>
    </el-drawer>
    <el-drawer title="设备类型详情" size="600px" :modal="false" :visible.sync="datailsShow" :wrapperClosable="false"
      direction="rtl" ref="drawer">
      <device-details-drawer v-if="datailsShow" :datailsData="details"></device-details-drawer>
    </el-drawer>
    <div class="mainContent" :style="styleObject">
      <div class="cardLists">
        <div class="card" v-for="(card,index) in cardLists" :key="index">
          <div class="cardContent">
            <div class="header ellipse clearfix">
              <i class="imgBoxs"><img :src="card.img ? require( '../../assets/img/devicetype/' + card.img)  : ''"
                  alt=""></i>
              <span :title="card.typeName">{{card.typeName}}</span>
            </div>
            <div class="text item">
              <div class="countAll">
                <b>{{card.enableCount ? card.enableCount : 0}}</b><span>/</span><b>{{card.totalCount ? card.totalCount : 0}}</b>
              </div>
              <div class="countName"><b>在线</b><span>/</span><b>总数</b></div>
            </div>
          </div>
        </div>
      </div>
      <div class="query">
        <span>
          <el-select v-model="selectedDevice" placeholder="选择设备注册至" @change="selectedDevicec" clearable>
            <el-option v-for="item in deviceOptions" :key="item.val" :label="item.label" :value="item.val"></el-option>
          </el-select>
          <el-select v-model="selectedZone" placeholder="选择通信协议方式" @change="selectedZonec" clearable>
            <el-option v-for="item in zoneOptions" :key="item.val" :label="item.label" :value="item.val"></el-option>
          </el-select>
          <el-select v-model="selectedIsonline" placeholder="是否启用" @change="selectedIsonlinec" clearable>
            <el-option v-for="item in isonlineOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <el-input v-model="searchText" autocomplete="off" placeholder="设备类型名称"
            @keyup.enter.native="serachData"></el-input>
          <button class="primaryBtn" @click="serachData">搜索</button>
        </span>
        <!-- v-if="isPermit('dev:add')" -->
        <button class="primaryBtn" @click="addClick('add')">新增设备类型</button>
        <!-- v-if="isPermit('dev:export')" -->
        <!-- <button class="primaryBtn" @click="exportExcel">报表导出</button> -->
        <button class="primaryBtn" @click="delAll">批量删除</button>
      </div>
      <div class="tableBox">
        <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading"
          :current-page="pagination.page" @selectionChange="handleSelectionChange"
          @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
          <el-table-column type="selection" width="50" border></el-table-column>
          <el-table-column prop="name" label="设备类型名称"></el-table-column>
          <!-- <el-table-column prop="registTo" label="设备注册至" :show-overflow-tooltip="true"></el-table-column> -->
          <!-- <el-table-column prop="protocol" label="通信协议方式" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="" label="设备注册至">
            <template slot-scope="scope">
              <div>
                {{scope.row.registTo == 0 ? 'X' : scope.row.registTo == 1 ? 'L' : scope.row.registTo == 2 ? 'D' : scope.row.registTo == 4 ? 'Y' : 'other'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="通信协议方式">
            <template slot-scope="scope">
              <div>{{scope.row.protocol==1 ? 'TCP' : 'UDP'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="是否启用">
            <template slot-scope="scope">
              <div :style="{color:scope.row.isEnabled ? '#00b050' : '#ff0000'}">
                {{scope.row.isEnabled==true ? '启用' : '禁用'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="heartBeat" label="设备心跳周期(单位:s)"></el-table-column>
          <el-table-column prop="alarmInterval" label="设备报警时间间隔(单位:s)" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="location" label="安装位置" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="createTime" label="添加时间" width="160">
            <template slot-scope="scope">
              <p>{{scope.row.createTime }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" size="small" class="edit">编辑</el-button>
              <el-button @click="delClick(scope.row)" size="small" class="del">删除</el-button>
              <el-button @click="detailClick(scope.row)" size="small" class="detail">详情</el-button>
            </template>
          </el-table-column>
        </border-table>
      </div>

    </div>
  </div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import DeviceDrawer from "@/components/deviceType/DeviceDrawer";
import DeviceDetailsDrawer from "@/components/deviceType/DeviceDetailsDrawer";
import axios from 'axios';
export default {
  //注册局部过滤器
  filters: {
    timefilters (val) {
      if (val == null || val == "") {
        return "暂无时间";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
          d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times =
          d.getFullYear() +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          min +
          ":" +
          sec;
        return times;
      }
    }
  },
  components: {
    BorderTable,
    DeviceDrawer,
    DeviceDetailsDrawer
  },
  data () {
    return {
      cardLists: [],
      loading: false,
      drawerShow: false,
      selectedDevice: null,
      deviceOptions: [
        {
          label: 'X',
          val: 0
        },
        {
          label: 'L',
          val: 1
        },
        {
          label: 'D',
          val: 2
        },
        {
          label: 'other',
          val: 3
        },
        {
          label: 'Y',
          val: 4
        }
      ],
      selectedZone: null,
      zoneOptions: [
        {
          label: 'TCP',
          val: 1
        },
        {
          label: 'UDP',
          val: 2
        }
      ],
      selectedIsonline: null,
      isonlineOptions: [{
        value: true,
        label: '启用'
      },
      {
        value: false,
        label: '禁用'
      }
      ],
      radio: "1",
      names: "",
      styleObject: {
        height: ""
      },
      tableLoading: false,
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      drawerTitle: "",
      drawerWidth: "500px",
      // orgId: this.storage.getSession("orgId"),
      searchText: "",
      handleType: '',
      checkDatas: [],
      selectData: {},
      details: {},
      datailsShow: false
    };
  },

  created () {
    this.makeheight();
    this.init()
    this.initData()
  },
  provide () {
    return {
      pinit: this.init,
      pinitdata: this.initData
    }
  },
  methods: {
    init () {
      this.request.post("/front/device/type/statistics").then(res => { //设备类型统计
        console.log(res)
        if (res.code == 200) {
          let cardDatas = []
          let obj = res.data
          let obj1 = {
            typeName: "所有设备类型",
            img: 'device.png'
          }
          Object.assign(obj, obj1)
          cardDatas.push(obj);
          // cardDatas.unshift({
          //   totalCount: 0,
          //   enableCount: 0,
          //   disabledCount:0,
          //   typeName: "所有设备类型",
          //   img:'device.png'
          // });

          // cardDatas.forEach(val => {
          //   cardDatas[0].totalCount += val.totalCount
          //   cardDatas[0].enableCount += val.enableCount
          // });
          this.cardLists = cardDatas
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      }).catch(error => {
        console.log(error)
      })
    },
    initData () {
      this.tableLoading = true;
      let setParams = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        name: this.searchText ? this.searchText : null,
        registTo: this.selectedDevice,
        protocol: this.selectedZone,
        isEnabled: this.selectedIsonline
      }
      this.request.post("/front/device/type/query", setParams).then(res => {
        console.log(res)
        this.tableLoading = false;
        if (res.code == 200) {
          this.dataList = res.data.data
          this.pagination.total = res.data.totalCount;
        } else if (res.code == 500) {
          this.msg.warn(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })

    },
    editClick (row) {
      //编辑
      this.selectData = row
      this.drawerShow = true;
      this.drawerTitle = "编辑设备类型";
      this.handleType = "edit";
    },
    //删除
    delClick (row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.request.delete("/front/device/type/del?ids=" + row.id).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              let num = ''
              if (this.pagination.total > 1) {
                num = (this.pagination.total - 1) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.init();
              this.initData();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    detailClick (row) { //详情
      // console.log(row)
      this.request.get("/front/device/type/" + row.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.details = res.data
          this.datailsShow = true
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      });
    },
    addClick (type) {
      //新增
      // this.backInit()
      this.drawerShow = true;
      this.drawerTitle = "新增设备类型";
      this.handleType = type
    },
    //关闭抽屉
    closeMess () {
      this.loading = false;
    },
    handleConfirm (data) { //确认
      console.log(data)
      if (data == 200) {
        this.drawerShow = false
        this.initData()
      }
    },
    handleCancel (data) { //取消
      console.log(data)
      this.drawerShow = false
    },
    serachData () {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "");
      this.pagination.currentPage = 1;
      this.initData();
    },
    handleSelectionChange (data) { //多选
      // console.log(data)
      this.checkDatas = data
    },
    delAll () {
      //批量删除
      if (this.checkDatas.length == 0) {
        this.msg.warn("请先勾选删除内容！")
      } else {
        let arr = []
        for (var i = 0; i < this.checkDatas.length; i++) {
          arr.push(this.checkDatas[i].id)
        }
        this.arry = arr
        console.log(this.arry)
        let params = {
          ids: this.arry.toString()
        }
        this.$confirm('此操作将永久删除内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.request.delete("/front/device/type/del", params).then(res => {
            // console.log(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              let num = ''
              if (this.pagination.total > this.pagination.pageSize) {
                num = (this.pagination.total - this.checkDatas.length) % this.pagination.pageSize
                if (num == 0) {
                  if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage = this.pagination.currentPage - 1
                  }
                }
              }
              this.initData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    //报表导出
    exportExcel () {
      this.$confirm(
        "没有进行条件筛选将导出全部数据，如果数据量过大请耐心等待，是否继续?",
        "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }
      ).then(() => {
        window.open(this.baseUrlAddr + '/deviceinstall/export?page=' + this.pagination.currentPage + '&pageSize=' + this.pagination.pageSize + '&orgId=' + this.orgId + (this.searchText ? '&key=' + this.searchText : '') + (this.selectedDevice ? '&devicetypeid=' + this.selectedDevice : '') + (this.selectedZone ? '&zoneid=' + this.selectedZone : '') + (this.selectedIsonline ? '&isOnline=' + this.selectedIsonline : ''))
      });
    },
    //选择设备类型
    selectedDevicec (data) {
      // this.selectedDevice = data
      // this.pagination.currentPage = 1;
      // this.initData()
    },
    //选择区域
    selectedZonec (data) {
      // this.selectedZone = data
      // this.pagination.currentPage = 1;
      // this.initData()
    },
    //在线状态
    selectedIsonlinec (data) {
      // console.log(data);

      // this.selectedIsonline = data
      // this.pagination.currentPage = 1;
      // this.initData()
    },
    //表格当前页变化时
    handleRoleCurrentChange (val) {
      this.pagination.currentPage = val;
      this.initData()
    },
    //表格展示条数变化时
    handleRoleSizeChange (val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.initData()
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight (height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.deviceType {
  .topTabs {
    height: 40px;
    background: #fff;
  }
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .cardLists {
      overflow: hidden;
      margin-bottom: 20px;
      // text-align: center;
      padding: 0 10px;
      .card {
        color: #212733;
        display: inline-block;
        width: 14.28%;
        height: 120px;
        box-sizing: border-box;
        padding: 0 10px;
        .cardContent{
          height: 120px;
          background-color: #cdeaf3;
          .header {
            padding: 9px 20px;
            border-bottom: 1px solid #E8E8E8;
            text-align: left;
            height: 20px;
            .imgBoxs {
              width: 20px;
              height: 20px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 8px;
              line-height: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
            span{
              vertical-align: middle;
              line-height: 20px;
            }
          }

          .text {
            text-align: center;
            margin-top: 15px;

            .countAll {
              color: #262C3A;
              font-weight: bolder;
              font-size: 24px;
              line-height: 24px;

              b {
                letter-spacing: 2px;
              }
            }

            .countName {
              margin-top: 8px;
              color: #808082;
              font-size: 14px;
              line-height: 14px;
            }
          }
        }

        &:first-child {
          .cardContent{
            .text {
              .countAll {
                color: #2277E4;
              }

              .countName {
                color: #2277E4;
              }
            }
          }

        }

      }
    }

    // .radio{
    //    margin: 20px 0;
    // }
    .query {
      padding: 0 20px 20px;
    }

    .tableBox{
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }

    // .btnS{
    //    color: #2A7EE1;
    //    border:1px solid #A1C6F3;
    //    background: #EFF3FC;
    //    margin-right:24px;
    //    &:hover{

    //    }
    // }
  }
}
</style>
<style lang="scss">
.deviceType {
  .mainContent {
    .query {
      .el-input {
        width: 380px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }
  }
}
</style>
